module.exports = __webpack_public_path__ + "assets/img/scond.f25fbb03.png";